import { ApiResponse, getRequest } from "@/data/apiClient";

export const userDecrypt = async (
  userName: string
): Promise<ApiResponse<{ userName: string }>> =>
  getRequest("decryptUsername", { userName });
